import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import * as React from 'react';
import { observer } from 'mobx-react';
import Decimal from 'decimal.js';
import Icon, { IconColor, IconType } from "../../../../media/Icon";
import { Utils } from "@logio/common-be-fe";
import { BigDecimal } from '@logio/big-decimal';
import translate from "../../../../i18n/translate";
import Tooltip from "../../../../info/Tooltip";

var BulkRenderer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BulkRenderer, _React$Component);

  function BulkRenderer(props) {
    var _this;

    _classCallCheck(this, BulkRenderer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BulkRenderer).call(this, props));
    _this.toggleValue = _this.toggleValue.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.store = _this.props.context.store; // Set colDef as our enahanced ColumnDefinition type

    _this.colDef = _this.props.column.getColDef(); // Attach event listeners to prevent edit of cells with no defined bulk function

    _this.preventEdit = _this.preventEdit.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    if (_this.props.node.rowPinned && _this.props.rowIndex === 0) {
      if (_this.colDef.bulkFunc === undefined) {
        _this.props.eGridCell.addEventListener('dblclick', _this.preventEdit);

        _this.props.eGridCell.addEventListener('mousedown', _this.preventEdit);
      }
    } else {
      _this.props.eGridCell.addEventListener('dblclick', _this.preventEdit);

      _this.props.eGridCell.addEventListener('mousedown', _this.preventEdit);
    }

    return _this;
  }

  _createClass(BulkRenderer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listeners to prevent edit of cells with no defined bulk function
      if (this.props.node.rowPinned && this.props.rowIndex === 0) {
        if (this.colDef.bulkFunc === undefined) {
          this.props.eGridCell.removeEventListener('dblclick', this.preventEdit);
          this.props.eGridCell.removeEventListener('mousedown', this.preventEdit);
        }
      } else {
        this.props.eGridCell.removeEventListener('dblclick', this.preventEdit);
        this.props.eGridCell.removeEventListener('mousedown', this.preventEdit);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isBulkRow = this.props.node.rowPinned && this.props.rowIndex === 0;
      var isAggRow = this.store.showBulkRow && this.store.showAggRow && this.props.rowIndex === 1 || !this.store.showBulkRow && this.store.showAggRow && this.props.rowIndex === 0;

      if (isAggRow) {
        return this.renderAgg();
      }

      if (isBulkRow) {
        return this.renderBulk();
      }

      return null;
    }
  }, {
    key: "renderAgg",
    value: function renderAgg() {
      var _this2 = this;

      if (this.props.colDef.aggFunc === "sum") {
        var sum = 0;
        this.props.api.forEachNode(function (node) {
          var rowValue = node.data[_this2.props.column.getColId()];

          if (!Utils.isValueMissing(rowValue)) {
            if (typeof rowValue === 'number') {
              sum += rowValue;
            }

            if (rowValue instanceof BigDecimal) {
              sum = rowValue.plus(sum).toNumber();
            }

            if (Decimal.isDecimal(rowValue)) {
              sum = rowValue.plus(sum);
            }
          }
        });

        if (this.props.colDef.valueFormatter) {
          return React.createElement("span", null, "\u03A3 ", this.props.colDef.valueFormatter({
            node: this.props.node,
            colDef: this.props.column.getColDef(),
            column: this.props.column,
            api: this.props.api,
            columnApi: this.props.columnApi,
            context: this.props.context,
            value: sum,
            data: sum
          }));
        } else {
          return React.createElement("span", null, "\u03A3 ", sum.toString());
        }
      }

      return null;
    }
  }, {
    key: "renderBulk",
    value: function renderBulk() {
      var _this3 = this;

      if (this.colDef.bulkFunc !== undefined) {
        return React.createElement(React.Fragment, null, this.props.cellIcon && React.createElement("div", {
          className: "fixed z1000"
        }, React.createElement(Tooltip, {
          overlay: translate(this.props.iconToolTip),
          placement: "right"
        }, React.createElement("div", null, this.props.cellIcon() ? React.createElement(Icon, {
          iconType: this.props.cellIcon(),
          iconColor: IconColor.Secondary,
          iconHeight: this.props.iconSize || 25,
          onClick: this.props.onIconClick
        }) : null))), React.createElement("span", {
          className: "ag-cell-icon",
          style: {
            position: 'absolute',
            right: 11
          },
          onClick: function onClick() {
            if (_this3.props.onClick) {
              _this3.props.onClick();
            }
          }
        }, React.createElement(Icon, {
          iconType: IconType.edit,
          iconColor: IconColor.Light,
          iconHeight: 25
        })));
      }

      return null;
    }
  }, {
    key: "toggleValue",
    value: function toggleValue(e) {
      var _this4 = this;

      // This toggle value on click
      if (this.colDef.bulkFunc !== undefined) {
        // Copy bulk function copies the same data to all selected rows
        var checked = this.store.selectedRows.every(function (node) {
          return node.data && node.data[_this4.props.column.getColId()];
        });
        var selected = this.props.api.getSelectedNodes();
        var editable = false;
        selected.forEach(function (node) {
          if (!node.aggData && !node.allChildrenCount) {
            node.setDataValue(_this4.props.column.getId(), !checked);
            editable = true;
          }
        });

        if (editable) {
          this.props.node.setDataValue(this.props.column.getId(), !checked);
        }
      }
    }
  }, {
    key: "preventEdit",
    value: function preventEdit(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }]);

  return BulkRenderer;
}(React.Component);

BulkRenderer = __decorate([observer, __metadata("design:paramtypes", [Object])], BulkRenderer);
export default BulkRenderer;